// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import {
  CHECKOUT_ORDER_DATA_SERVICE_ENDPOINT,
  SAVE_REDIRECT_DATA_SERVICE_ENDPOINT,
} from 'providers/checkout/services/constants/checkout.service.constants';

const fetchCheckoutOrderDataService = async (): Promise<any> =>
  apiUtils.get(CHECKOUT_ORDER_DATA_SERVICE_ENDPOINT);

const saveRedirectDataService = async (device: string): Promise<[null, Response]> =>
  apiUtils.post({
    ...SAVE_REDIRECT_DATA_SERVICE_ENDPOINT,
    params: { ...SAVE_REDIRECT_DATA_SERVICE_ENDPOINT.params, device },
  });

export { fetchCheckoutOrderDataService, saveRedirectDataService };
